module.exports = new __parcel__URL__("hiphop_bg.b37ba8be.jpg").toString();